import React, { useState } from "react";
import Header from "./Components/Header/Header.component";
import ScrollToTop from "./Helpers/ScrollToTop";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import ShopPage from "./Pages/ShopPage";
import ProductPage from "./Pages/ProductPage";

const App = () => {
  const [showCart, setShowCart] = useState(false);

  const [loginModal, setLoginModal] = useState(false);
  const [RegisterModal, setRegisterModal] = useState(false);

  const handleLoginModal = () => {
    setRegisterModal(false);
    setLoginModal(!loginModal);
  };

  const handleRegisterModal = () => {
    console.log("Open");
    setRegisterModal(!RegisterModal);
    setLoginModal(false);
  };

  function handleCartModal(state) {
    setShowCart(state);
  }

  return (
    <div className="App">
      <ScrollToTop />
      <div>
        <Header
          handleShowCart={handleCartModal}
          handleLoginModal={handleLoginModal}
          loginModal={loginModal}
          RegisterModal={RegisterModal}
          handleRegisterModal={handleRegisterModal}
        />
        <Routes>
          <Route exact path="/" element={<HomePage />}></Route>
          <Route exact path="/shop" element={<ShopPage />}></Route>
          <Route exact path="/:productName" element={<ProductPage />}></Route>
        </Routes>
      </div>
    </div>
  );
};

export default App;
